/** @jsxImportSource @gasman/smush */

import { ContainerComponent } from '@gasman/smush';

import { Counter } from '../widgets/counter';

class SongControls extends ContainerComponent {
    constructor(app, engine) {
        super();

        this.tempoSelector = Counter.forField(engine.Song.fields.tempo);
        this.songLengthSelector = Counter.forField(engine.Song.fields.length);

        this.components = [this.tempoSelector, this.songLengthSelector];
    }

    render(container) {
        container.appendChild(
            <div class="song-controls">
                {this.tempoSelector}
                {this.songLengthSelector}
            </div>,
        );
    }

    bind(song, opts) {
        this.tempoSelector.bind(song, opts);
        this.songLengthSelector.bind(song, opts);
    }
    unbind() {
        this.tempoSelector.unbind();
        this.songLengthSelector.unbind();
    }
}

export { SongControls };
